import React from 'react';
import SelectField from '../../forms/SelectField';
import { toSelectionFormat } from '../../../lib/collection.utils';
import { filter, find } from 'lodash';
import CategoryVisibilitySelector from '../forms/CategoryVisibilitySelector';
import CopyFromPartnerFields from './CopyFromPartnerFields';

const EventPartnerInputs = ({ onInput, data, dependencies, staticData }) => {
    const partners = dependencies.partners || [];
    const categories = dependencies.categories || [];
    const selectedCategories = data.categoryIds || [];
    const existingEventPartners = staticData || [];
    const copyFromPartnerId = data.copyFromPartnerId || '';
    const copyClearances = copyFromPartnerId ? data.copyClearances !== false : false;
    const copyVisibleCategories = copyFromPartnerId ? data.copyVisibleCategories !== false : false;

    const handleCategoryChange = updatedCategories => {
        onInput(updatedCategories, 'categoryIds');
    };

    const handleCopyFromChange = value => {
        onInput(value, 'copyFromPartnerId');
        if (value) {
            onInput(true, 'copyClearances');
            onInput(true, 'copyVisibleCategories');
        }
    };

    const showDefaultCategories =
        data.partnerIds?.length > 0 && categories.length > 0 && !(copyFromPartnerId && copyVisibleCategories);

    return (
        <React.Fragment>
            <div className="ckp-admin-grid-column">
                <SelectField
                    name="partnerIds"
                    onChange={onInput}
                    value={data.partnerIds}
                    label="Media Partners *"
                    multiple={true}
                    items={toSelectionFormat(filter(partners, dp => !find(staticData, sd => sd.id === dp.id)))}
                />
            </div>
            {existingEventPartners.length > 0 && (
                <div className="u-margin-top-2">
                    <CopyFromPartnerFields
                        selectLabel="Copy from"
                        selectName="copyFromPartnerId"
                        selectItems={[
                            { value: null, label: 'None' },
                            ...existingEventPartners.map(x => ({ value: x.id, label: x.name }))
                        ]}
                        selectValue={copyFromPartnerId}
                        onSelectChange={handleCopyFromChange}
                        copyClearances={copyClearances}
                        copyVisibleCategories={copyVisibleCategories}
                        onCopyClearancesChange={() => onInput(!copyClearances, 'copyClearances')}
                        onCopyVisibleCategoriesChange={() => onInput(!copyVisibleCategories, 'copyVisibleCategories')}
                        showCheckboxes={!!copyFromPartnerId}
                        showValidationError={!!copyFromPartnerId && !copyClearances && !copyVisibleCategories}
                        displayEmpty={true}
                    />
                </div>
            )}
            {showDefaultCategories && (
                <CategoryVisibilitySelector
                    categories={categories}
                    selectedCategories={selectedCategories}
                    onChange={handleCategoryChange}
                    label="Default Visible Categories"
                />
            )}
        </React.Fragment>
    );
};

export default EventPartnerInputs;
